export function requiresHeartbeat(statusCode: number): boolean {
    return statusCode === 403 || statusCode === 360;
}

export function timeoutOccurred(statusCode: number, statusText: string): boolean {
    return statusCode === 0 && statusText === "timeout";
}
